import React, { lazy } from "react";
import PrivateRoute from "../../components/PrivateRoute";
import { Routes } from "../../context/App";

const Subscription = lazy(() => import("../../pages/Subscription"));

interface SubscriptionProps {
  route: typeof Routes.SUBSCRIPTIONS;
  path: string;
  exact: boolean;
}

const SubscriptionRoute: React.FC<SubscriptionProps> = (props) => {
  const { route, path, exact } = props;
  return (
    <PrivateRoute
      path={path}
      route={route}
      exact={exact}
      Component={Subscription}
    />
  );
};

export default SubscriptionRoute;
